<template>
  <div class="container">
    <div class="goBackBtn" @click="$router.go(-1)">
      <h2>
        X
      </h2>
    </div>
    <div class="modal-body terms-conditions" v-html="tycos"></div>
  </div>
</template>

<script>
export default {
  name: "Terms",
  props: {
    name: {
      type: String,
      default: "cuamoc.com.mx"
    }
  },
  data() {
    return {
      tycos: "",
    };
  },
  async mounted() {
    const Axios = require("axios");

    const options = {
      method: "GET",
      url: "https://api-mx-marketing.azure-api.net/sitios/tycos",
      headers: {
        campaign: "general",
      },
    };

      let response = await Axios.request(options);
      this.tycos = response.data.replace("{", "").replace('"body":"', "").replace('";', "").replace('}', "").replace("[[urlsitio]]", "https://millerhighlife.com.mx/");
  },
};
</script>
<style lang="scss" >
.container {
  padding-top: 0vw;
  @media screen and (max-width: 768px) {
    padding-top: 13vw;
  }
}
.goBackBtn {
  display: flex;
  flex-direction: row;
  width: 80px;
  background-color: transparent;
  border: none;
  font-family: 'DINRegular' !important;
  font-size: 1.4vw;
  float: right;
  position: absolute;
  top: 0px;
  right: 0px;
  color: #9E895C;
  h2 {
    margin-inline: 0;
  }
  @media screen and (max-width: 768px) {
    width: 42px;
    h2 {
      font-size: 4.8vw;
    }
  }
}
.goBackBtn:hover {
  cursor: pointer;
}
.terms-conditions {
  font-family: 'DINRegular' !important;
  font-size: 1.3vw !important;
  margin-right: 4.2pt !important;
  margin-left: 4.2pt !important;
  text-align: justify;
  padding-inline: 2vw;
  margin-top: 7vw !important;
  h2 {
    margin-bottom: 2vw !important;
  }
  h3, p{
    margin: 0;
    margin-bottom: 1rem;
  }
  @media (max-width: 768px) {
    font-size: 4.9vw !important;
  }
  *{
  font-family: 'DINRegular' !important;
  font-size: 1.3vw !important;
  @media (max-width: 768px) {
    font-size: 4.9vw !important;
  }
  }
}
</style>
